import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    stockInfoData: {
        symbol: "NIFTY",
        exchange: "N",
        exchangeType: "C",
        scripCode: 999920000,
        lastTradePrice: 123,
        previousClose: 879,
        expiry: "2022-11-24T00:00:00Z",
        StrikeRate: "",
    },
    callFunctionFromDashboard: () => { },
};
export const stockInfo = createSlice({
    name: "stock-info",
    initialState: initialState,
    reducers: {
        stockInfoData: (state, action) => {
            state.stockInfoData = action.payload;
        },
        callFunctionFromDashboard: (state, action) => {
            state.callFunctionFromDashboard = action.payload;
        },
    },
});
export const { stockInfoData, callFunctionFromDashboard } = stockInfo.actions;
export default stockInfo.reducer;
